<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-top">
        <div class="footer-logo">
          <img src="../../assets/images/icons/logo.png" alt="矢量律动" />
          <h3>矢量律动</h3>
          <p>用AI让每一个硬件拥有智能</p>
        </div>
        <div class="footer-links">
          <div class="links-group">
            <h4>关于我们</h4>
            <ul>
              <li><router-link to="/about">公司简介</router-link></li>
              <li><router-link to="/about">企业文化</router-link></li>
            </ul>
          </div>
          <div class="links-group">
            <h4>技术能力</h4>
            <ul>
              <li><router-link to="/technology">AI算法研发</router-link></li>
              <li><router-link to="/technology">智能体平台</router-link></li>
              <li><router-link to="/technology">硬件集成能力</router-link></li>
              <li><router-link to="/technology">研究与创新</router-link></li>
            </ul>
          </div>
          <div class="links-group">
            <h4>产品与应用</h4>
            <ul>
              <li><router-link to="/products">智能体平台</router-link></li>
              <li><router-link to="/products">智能穿戴</router-link></li>
              <li><router-link to="/products">智能互动</router-link></li>
            </ul>
          </div>
          <div class="links-group">
            <h4>联系我们</h4>
            <ul>
              <li><router-link to="/contact">公司地址</router-link></li>
              <li><router-link to="/contact">联系方式</router-link></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="copyright">
          <p>© {{ currentYear }} 深圳市矢量律动科技有限公司 保留所有权利</p>
          <p><a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2025410794号</a></p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.footer {
  background-color: #2a184f;
  color: white;
  padding: 70px 0 30px;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-top {
  display: flex;
  flex-wrap: wrap;
  gap: 50px;
  margin-bottom: 60px;
}

.footer-logo {
  flex: 1;
  min-width: 250px;
}

.footer-logo img {
  height: 50px;
  width: auto;
  margin-bottom: 15px;
  object-fit: contain;
}

.footer-logo h3 {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.footer-logo p {
  font-size: 1rem;
  opacity: 0.8;
}

.footer-links {
  flex: 3;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.links-group {
  flex: 1;
  min-width: 150px;
  margin-bottom: 30px;
}

.links-group h4 {
  font-size: 1.2rem;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;
}

.links-group h4::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 30px;
  height: 2px;
  background-color: #d76d77;
}

.links-group ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.links-group li {
  margin-bottom: 10px;
}

.links-group a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.3s ease;
}

.links-group a:hover {
  color: #d76d77;
}

.footer-bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}


.copyright{
  justify-content: center;
  align-items: center;
}

.copyright p {
  font-size: 0.9rem;
  opacity: 0.7;
  text-align: center;
}

.copyright a {
  font-size: 0.9rem;
  opacity: 0.7;
  color: white;
  text-align: center;
}
@media (max-width: 768px) {
  .footer-top {
    flex-direction: column;
    gap: 40px;
  }
  
  .footer-links {
    flex-direction: column;
    gap: 30px;
  }
  
  .links-group {
    width: 100%;
    margin-bottom: 0;
  }
  
  .footer-bottom {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
}
</style> 